<!-- The .invalid-field class is used in scroll-to-invalid-control.utility.ts -->
<label
    [class.errored]="errored()"
    [class.invalid-field]="errored()"
    [class.disabled]="_disabled"
    [class.checked]="_checked"
    [class.indeterminate]="_indeterminate"
    [class.no-spacing]="noSpacing()"
    [class.spacing-sm]="spacingSmall()"
    [tabIndex]="labelHasTabindex() ? 0 : -1"
    [attr.data-id]="id()"
    (click)="toggleChecked($event)"
>
    <div
        class="checkbox"
        [class.enforce-cursor-pointer]="onlyAllowCheckboxClick()"
        [tabindex]="labelHasTabindex() ? -1 : 0"
        (keydown.enter)="toggleChecked($event)"
    >
        @if (_indeterminate) {
            <stby-icon icon="minus" size="14" />
        } @else {
            <stby-icon icon="check" size="14" />
        }
    </div>

    @if (label) {
        <span class="label-text">
            {{ label }}
        </span>
    }

    <span class="label-text">
        <ng-content #contentWrapper selects="stby-checkbox-label"></ng-content>
    </span>

    @if (tooltip) {
        <stby-tooltip [tooltip]="tooltip" />
    }
</label>

@if (formControl && !errored()) {
    <stby-form-control-errors
        [formControlItem]="formControl"
        [alwaysShowErrors]="alwaysShowErrors()"
        [requiredLabel]="requiredLabel() || label"
    />
}
